import React from "react";
import classNames from "classnames";
import { Draggable, DropBox } from "@common/dragAndDrop";
import { useMoveKanbanTask } from "@planzone/view-models";

import { Props } from "./types";
import { Task } from "./task";
import styles from "./styles.scss";

function Tasks({ tasks, column, project }: Props) {
  const { moveKanbanTask } = useMoveKanbanTask();

  return (
    <div className={styles.tasks}>
      <DropBox
        acceptedTypes={["MOVE_TASK"]}
        drop={({ payload }) =>
          moveKanbanTask({
            currentColumn: payload.column,
            nextColumn: column,
            range: {
              max: column.tasks[0] || null,
              min: null,
            },
            task: payload.task,
          })
        }
        verticalSlop={{ top: 30 }}
      >
        {({ payload }, canDrop) => (
          <div
            className={classNames(styles.task, styles.dropPreview, {
              [styles.dropPreviewVisible]: canDrop,
            })}
          >
            {canDrop && <Task task={payload.task} project={project} />}
          </div>
        )}
      </DropBox>
      {tasks.map((task, index) => (
        <DropBox
          acceptedTypes={["MOVE_TASK"]}
          drop={({ payload }) =>
            moveKanbanTask({
              currentColumn: payload.column,
              nextColumn: column,
              range: {
                min: task,
                max: column.tasks[index + 1] || null,
              },
              task: payload.task,
            })
          }
        >
          {({ payload }, canDrop) => (
            <React.Fragment>
              {!project.isTemplate ? (
                <Draggable
                  key={task.uuid}
                  data={{ task, column }}
                  type="MOVE_TASK"
                  className={classNames(styles.task, {
                    [styles.dragged]:
                      payload.task && payload.task.uuid === task.uuid,
                  })}
                >
                  <Task task={task} project={project} />
                </Draggable>
              ) : (
                <div className={styles.task}>
                  <Task task={task} project={project} />
                </div>
              )}
              <div
                className={classNames(styles.task, styles.dropPreview, {
                  [styles.dropPreviewVisible]: canDrop,
                })}
              >
                {canDrop && <Task task={payload.task} project={project} />}
              </div>
            </React.Fragment>
          )}
        </DropBox>
      ))}
    </div>
  );
}

export { Tasks };
